module.exports = __webpack_public_path__ + "ad8c05d8c38bfb9de0c56c98d234239a.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-regular-italic.eot
// module id = 20
// module chunks = 0